function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { invariant, includes, shouldBeOneOf } from './utils';
var typeOptions = ['upload', 'fetch', 'facebook', 'twitter', 'twitter_name', 'instagram', 'instagram_name', 'gplus', 'gravatar'];
export var compile = function compile(parameterSet, transform, defaultTransform) {
  if (!parameterSet) {
    return '';
  }

  var compile = function compile(parameters) {
    return Object.keys(parameters).map(function (param) {
      return parameterSet(param, parameters[param]);
    }).filter(Boolean).join(',');
  };

  var compiledTransform = Array.isArray(transform) ? transform.map(compile).join('/') : compile(_objectSpread({}, defaultTransform, {}, transform));
  return compiledTransform ? "/" + compiledTransform : '';
};

var urlBuilder = function urlBuilder() {
  var parameterSets = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var baseResourceType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'image';
  return function (_ref) {
    var cloudName = _ref.cloudName,
        _ref$cdnSubdomain = _ref.cdnSubdomain,
        cdnSubdomain = _ref$cdnSubdomain === void 0 ? false : _ref$cdnSubdomain,
        _ref$cname = _ref.cname,
        cname = _ref$cname === void 0 ? 'res.cloudinary.com' : _ref$cname,
        _ref$secure = _ref.secure,
        defaultSecure = _ref$secure === void 0 ? true : _ref$secure,
        _ref$defaults = _ref.defaults;
    _ref$defaults = _ref$defaults === void 0 ? {} : _ref$defaults;

    var _ref$defaults$type = _ref$defaults.type,
        defaultType = _ref$defaults$type === void 0 ? 'upload' : _ref$defaults$type,
        _ref$defaults$resourc = _ref$defaults.resourceType,
        defaultResourceType = _ref$defaults$resourc === void 0 ? baseResourceType : _ref$defaults$resourc,
        defaultTransform = _objectWithoutPropertiesLoose(_ref$defaults, ["type", "resourceType"]);

    process.env.NODE_ENV !== 'production' && invariant(cloudName, 'cloudName', cloudName, 'configuration is required', '/node_additional_topics#configuration_options');
    var baseUrl = cname + "/" + cloudName + "/";
    var sub = '';
    return function (publicId) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var _options$resourceType = options.resourceType,
          resourceType = _options$resourceType === void 0 ? defaultResourceType : _options$resourceType,
          _options$secure = options.secure,
          secure = _options$secure === void 0 ? defaultSecure : _options$secure,
          _options$type = options.type,
          type = _options$type === void 0 ? defaultType : _options$type,
          _options$version = options.version,
          version = _options$version === void 0 ? '1' : _options$version,
          transform = _objectWithoutPropertiesLoose(options, ["resourceType", "secure", "type", "version"]);

      if (options.transform) {
        transform = options.transform;
      } else if (Array.isArray(options)) {
        transform = options;
      }

      process.env.NODE_ENV !== 'production' && invariant(!transform || Object.keys(transform).length === 0 || resourceType === 'raw' || includes(resourceType, Object.keys(parameterSets)), 'resourceType', resourceType, shouldBeOneOf(['raw'].concat(Object.keys(parameterSets))) + ', fix the resource type or add additional transform parameters to the configuration', null);
      process.env.NODE_ENV !== 'production' && invariant(includes(type, typeOptions), 'type', type, shouldBeOneOf(typeOptions), null);
      process.env.NODE_ENV !== 'production' && invariant(!cdnSubdomain || typeof cdnSubdomain === 'function', 'cdnSubdomain', cdnSubdomain, 'should be a CRC function: `(string) => number`', null);

      if (cdnSubdomain) {
        sub = "a" + (cdnSubdomain(publicId) % 5 + 1) + ".";
      }

      transform = compile(parameterSets[resourceType], transform, defaultTransform);
      return "http" + (secure ? 's' : '') + "://" + sub + baseUrl + resourceType + "/" + type + transform + "/v" + version + "/" + publicId;
    };
  };
};

export default urlBuilder;